import {Role, UserSearchCriteria, UsersSortField} from 'web-angular-client';

export class UserSearchCriteriaImpl implements UserSearchCriteria
{
    email?: string;
    mobile?: string;
    name?: string;
    role?: Role;
    userStatus?: UserSearchCriteria.UserStatusEnum;
    surname?: string;
    usersSortField?: UsersSortField;

    constructor()
    {
        this.email = null;
        this.mobile = null;
        this.name = null;
        this.role = null;
        this.userStatus = UserSearchCriteria.UserStatusEnum.ANY;
        this.surname = null;
        this.usersSortField = UsersSortField.ID;
    }
}